import { getEnvConfig } from 'envConfig';
import jsCookie from 'js-cookie';

const impersonatedUserIdKey = 'genie-impersonatedUser';

let skipCookieChange = false;
const cookieChange = (e: Event) => {
  if (skipCookieChange) {
    return;
  }

  // @ts-ignore
  const changedCookies = e.changed as { name: string; value: string }[];
  if (!changedCookies.some((c) => c.name === impersonatedUserIdKey)) {
    return;
  }

  console.debug('impersonation change', e);
  // as localStorage shared across tabs we need to reload the page to keep data consistent with the new user
  window.location.reload();
};

try {
  window.cookieStore.addEventListener('change', cookieChange);
} catch (e) {
  console.error('Error adding cookie change listener', e);
}

export const saveImpersonatedUserId = (id: string): void => {
  const impersonationId = getSavedImpersonatedUserId();
  if (impersonationId !== id) {
    skipCookieChange = true;
    const config = getEnvConfig();
    jsCookie.set(impersonatedUserIdKey, id, {
      domain: config.cookieSettings.domain,
      sameSite: config.cookieSettings.sameSite,
      secure: config.cookieSettings.secure,
    });
    skipCookieChange = false;
  }
};

export const clearImpersonatedCognitoUsername = (): void => {
  const impersonationId = jsCookie.get(impersonatedUserIdKey) ?? null;
  if (impersonationId) {
    skipCookieChange = true;
    const config = getEnvConfig();
    jsCookie.remove(impersonatedUserIdKey, {
      domain: config.cookieSettings.domain,
      sameSite: config.cookieSettings.sameSite,
      secure: config.cookieSettings.secure,
    });
    skipCookieChange = false;
  }
};

export const getSavedImpersonatedUserId = (): string | null => {
  const impersonationUserId = jsCookie.get(impersonatedUserIdKey) ?? null;
  if (impersonationUserId) {
    return impersonationUserId;
  }

  return null;
};
